import { useEffect } from "react";

declare interface PageTitleProps {
	title: string;
}

export const PageTitle = ({ title }: PageTitleProps) => {
	useEffect(() => {
		document.title = title;
	}, [title]);

	return null;
};

export default PageTitle;
